export const HELPER_TEXT = 'RECUERDA: Los pagos realizados se verán reflejados en el sistema, hasta en 4 días hábiles.';
export const EXECUTE_PAYMENT_TEXT = 'Realizar pago de:';
export const SELECT_OPTION_TEXT = 'Selecciona una opción:';
export const PAYMENT_TYPE_CASH = 'Efectivo y Puntos Físicos';
export const PAYMENT_TYPE_PSEE = 'Débito bancario PSE';
export const BANCOLOMBIA = 'Bancolombia';
